import React, { useEffect, useState } from 'react';
import Layout from '../Components/Layout/Layout';
import AddIco from "../Components/Images/plus-add-ico.svg";
import Datatable from '../Components/Datatable/Datatable';
import { Link } from 'react-router-dom';
import { FormatDate, GetApiWithoutToken, PostApi, PostApiWithoutLogin } from '../apiService';
import { API_PATH } from '../const';
import Loader from '../Components/Layout/Loader';

export default function Inquiries() {

    const [advList, setAdvList] = useState([]);
    const [loader, set_loader] = useState(false);

    const columnList = ["name", "email", "message", "date"]

    useEffect(() => {
        set_loader(true);
        getAdvList();
    }, [])

    const getAdvList = () => {
        const query = {
            "page": 1,
            "sizePerPage": 50
        }
        const FeaturedAdvData = Promise.resolve(PostApi(API_PATH.GetInquiries, query));
        FeaturedAdvData.then(response => {
            if(response.status === 200) format_data(response.data?.data?.inquiries_fetched ?? []);
            else setAdvList([]);
            set_loader(false);
        })
    }

    const format_data = (data) => {
        if(data.length > 0) {
            let formated_data = [];
            data.forEach(item => {
                let formated_item = {
                    "id": item._id ?? "-",
                    "name": item.firstname + " " + item.lastname,
                    "email": item.email ?? "-",
                    "message": item.message ?? "-",
                    "date": FormatDate(item.created_at) ?? "-",
                }
                formated_data.push(formated_item);
            })
            setAdvList(formated_data);
        } else setAdvList([]);
    }
 

    return (
        <Layout>
            {loader === true ? <Loader></Loader> : <></>}
            <div className="nav-top-section">
                <div className="container-fluid ">
                    <div className="row">
                        <div className="col-12 mt-3">
                            <div className="bx-white-main">
                                <div className="d-flex align-items-center">
                                    <h2 className="mb-0">Inquiries</h2>
                                    <div className="ms-auto">
                                        {/* <Link to="/add-advertise" className="btn-all-comn d-flex justify-content-center align-items-center">
                                            <img src={AddIco} className="me-2" loading="lazy" alt="" />
                                            Add New Advertisement
                                        </Link> */}
                                    </div>
                                </div>
                                <div className="pt-2 mt-1">
                                    <Datatable column={columnList} data={advList} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}